import React from 'react';
import './NewsAbout2.css'

const NewsAbout2 = () => {
    return (
        <div className="">

      
        <div className=" py-5 container">
        {/* <div className='img-style-about'>
               <img width="80%" height={450} src="https://i.ibb.co/dQPmG3g/newsEve2.jpg" alt="" />
           </div> */}
           <div className="my-5 py-5">
           
              
               <p  sx={{textAlign: 'left'}} className="text-dark-50 fs-6 mb-5 large-text">
               <h4 className="text-dark-50 text-primary text-news2">Internship opportunity for enthusiastic people </h4>
                   Just having a good degree is no longer enough to secure that all-important graduate job offer in today’s world. Pertinent work experience is now just as valuable as your degree and exam results when it comes to building a successful career. As a result, internships have become an essential way to help candidates make themselves stand out. An internship is an official program offered by organisations to help train and provide work experience to students and recent graduates. The concept of working as an intern began a long time ago but has drastically evolved over the years. Internships first started as a labourer who would take on young individuals and teach them their art or trade. In exchange for being taught a skill, the trainee would agree to work for the labourer for a specific time. Even then, the purpose of an internship or rather an apprenticeship was to gain new skills to be able to obtain future work. This is a virtual internship offer by Uddog o Uddokta Japan Association which is a registered social organization in Japan.
                   <br />
                  <br />
                  <div className='internship'>
                      <div>
                      <span className='fw-bold'>Duration:</span>  6 months/200 hours <br />
<span className='fw-bold'>Period:</span> 01 May to 30 October 2022 <br />
<span className='fw-bold'>Work Medium:</span>  Online <br />
<span className='fw-bold'>Reporting: </span> Online meeting <br />

 <span className='fw-bold'>Department: </span>  ICT, Project Management, <br /> Financial Management,  Branding & Promotions, and Research. <br />
<span className='fw-bold'>No of vacancies:</span> 05 <br />
<span className='fw-bold'>Eligibility:</span> University students from Japan/Bangladesh <br />
<span className='fw-bold'>Application:</span> Please send an email writing your interest along with CV <br />
<span className='fw-bold'>E-mail:</span> info.uujp@gmail.com <br /> 
                      </div>
                      <img className='img-style-about' width="40%" src="https://i.ibb.co/dQPmG3g/newsEve2.jpg" alt="" />
                  </div>


                {/* <span className='fw-bold'>Duration:</span>  6 months/200 hours <br />
<span className='fw-bold'>Period:</span> 01 May to 30 October 2022 <br />
<span className='fw-bold'>Work Medium:</span>  Online <br />
<span className='fw-bold'>Reporting: </span> Online meeting <br />

 <span className='fw-bold'>Department: </span>  ICT, Project Management, <br /> Financial Management,  Branding & Promotions, and Research. <br />
<span className='fw-bold'>No of vacancies:</span> 05 <br />
<span className='fw-bold'>Eligibility:</span> University students from Japan/Bangladesh <br />
<span className='fw-bold'>Application:</span> Please send an email writing your interest along with CV <br />
<span className='fw-bold'>E-mail:</span> info.uujp@gmail.com <br /> */}
</p>


{/* <p className='eligibility-text mt-3'> <span className='fw-bold'>Duration:</span>  6 months/200 hours <br />
<span className='fw-bold'>Period:</span> 01 May to 30 October 2022 <br />
<span className='fw-bold'>Work Medium:</span>  Online <br />
<span className='fw-bold'>Reporting: </span> Online meeting <br />

 <span className='fw-bold'>Department: </span>  ICT, Project Management, <br /> Financial Management,  Branding & Promotions, and Research. <br />
<span className='fw-bold'>No of vacancies:</span> 05 <br />
<span className='fw-bold'>Eligibility:</span> University students from Japan/Bangladesh <br />
<span className='fw-bold'>Application:</span> Please send an email writing your interest along with CV <br />
<span className='fw-bold'>E-mail:</span> info.uujp@gmail.com <br />
</p>   */}


           </div>
   
       </div>
        

       
{/*    
       <div className="about-all py-5">
           
           <div className="py-5 container">
               
               <p className="text-dark-50 container fs-6">As we are working on Entrepreneurship Development to solve the social problems, we have decided to help them to overcome their obstacles and free them from poverty.
What exactly we are planning to do?
- To provide a suitable Basic Business Training 
- To provide Basic Machineries, Raw Materials, Working Capital to start their own business 
- To establish market place in Bangladesh and Japan to introduce their quality products and ensure a regular sale zone
- To provide necessary guidance for business operations, they will be under our close monitoring and follow up for 3 years 
This is a donation base project. Any one can contribute in this project who is eager to support poor women for their better livelihood. You can donate for at least 1 woman!
 
MoU signing ceremony was held on 26th January 2021 at Zhumka Bangladesh Office, Dhaka, Bangladesh. Ms Shirin Jahan, Executive Director of Uddog o Uddokta Foundation, Bangladesh, Ms Samira Hossain, Director, Uddog o Uddokta Japan Association, Ms Sharmin Kabir Bina, Executive Director of Zhumka Bangladesh, Ms Shegufta Nadi, Director of Zhumka Bangladesh and Mr Monir Hossain, Program Manager of Zhumka Bangladesh was present in the ceremony.



</p>
           </div>
           <div className="my-2 py-5">
               <img src="" alt="" />
           </div>
       </div> */}



       
   </div>
    );
};

export default NewsAbout2;